import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { ClienteTypeaheadSharedModule } from '../../../pessoa/cliente/typeahead';
import { CidadeModule } from '../../../cidade';
import { EstadoMultiselectModule } from '../../../estado/multiselect';
import { ClassificacaoTipoMultiselectModule } from '../../../classificacao/tipo/multiselect';
import { ItemSharedModule } from '../../../item/item-shared.module';
import { RepresentanteMultiselectModule } from '../../../pessoa/representante/multiselect';
import { PedidoStatusModule } from '../../../pedido/status/pedido-status.module';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';

import { CurvaAbcVendaFilterComponent } from './curva-abc-venda-filter.component';

@NgModule({
    imports: [
        SharedModule,
        ClienteTypeaheadSharedModule,
        CidadeModule,
        EstadoMultiselectModule,
        ClassificacaoTipoMultiselectModule,
        ItemSharedModule,
        RepresentanteMultiselectModule,
        PedidoStatusModule,
        MultiselectDropdownModule
    ],
    declarations: [
        CurvaAbcVendaFilterComponent
    ],
    exports: [
        CurvaAbcVendaFilterComponent
    ]
})
export class CurvaAbcVendaFilterModule {}
